/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'check': {
    width: 13,
    height: 11,
    viewBox: '0 0 13 11',
    data: '<path pid="0" fill-rule="evenodd" d="M10.636 0L5.121 5.515 2.364 2.758 0 5.121l5.121 5.121L13 2.364z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/check.js